import React from 'react'

export default function DailyDashboardReport() {
  return (
    <div>
      Daily Dashboard Report
    </div>
  )
}
